import { memo } from 'react';
import { Grid } from '@mui/material';
import { SonFormVM } from 'front-office/view-models/certificate/son-form';
import PmiTextField from 'shell/components/shared/text-field';
import ForeignStateList from 'shell/components/shared/foreign-state-list';
import MunicipalityForeignList from 'shell/components/shared/municipality-foreign-list';
import { noop } from 'shell/utils/noop';

interface ResidenceForeignProps {
  son?: SonFormVM;
  onChange: (key: keyof SonFormVM, value: SonFormVM[keyof SonFormVM]) => void;
}

const ResidenceForeignComponent = ({
  son,
  onChange,
}: ResidenceForeignProps): React.ReactElement => {
  return (
    <Grid item container spacing={2}>
      <Grid item xs={12} md={5}>
        <ForeignStateList
          value={son?.foreignStateResidence || null}
          onChange={(value) => onChange('foreignStateResidence', value)}
          label="Stato estero di residenza"
          id="foreignStateResidence"
        />
      </Grid>
      <Grid item xs={12} md={9}>
        <MunicipalityForeignList
          value={son?.foreignMunicipalityResidence || null}
          onChange={(municipality) => onChange('foreignMunicipalityResidence', municipality)}
          label="Comune estero di residenza"
          id="foreignMunicipalityResidence"
          foreignStateIstatCode={son?.foreignStateResidence?.istatCode || ''}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="foreignProvince"
          name="foreignProvince"
          fullWidth
          type="text"
          variant="outlined"
          onChange={noop}
          value={son?.foreignMunicipalityResidence?.province || ''}
          disabled
        />
      </Grid>
    </Grid>
  );
};

ResidenceForeignComponent.displayName = 'Residence Foreign component';

const ResidenceForeign = memo(ResidenceForeignComponent);

export default ResidenceForeign;
